import {useEffect} from "react";
import { useSelector,useDispatch } from "react-redux"
import { newsRequest } from "features/News/newsSlice";
 

const useNewsList = (start,limit) => {
   const dispatch = useDispatch();

   useEffect(()=>{
     dispatch(newsRequest([start,limit]));
   },[start,limit,dispatch]);

   return useSelector((state)=>{
     if(state.news.newsArray) return state.news.newsArray;
     return [];
   })
}

export default useNewsList;
